import { getFirestore, doc, collection, getDocs, onSnapshot } from "firebase/firestore"
import getCollectionPath from '@/services/firestore/getCollectionPath'
import catalogueCommands from '@/commands/catalogueCommands'

const db = getFirestore()
const collectionName = 'stuffs/'

function docToInstance(doc) {
  const data = doc.data()
  return data ? new Stuff(doc.id, data.name, data.image, data.description, data.type, data.level, data.buyingMode, data.price, data.amortization, data.lossOnSale, data.paimentDelay, data.charges, data.maintnanceCost, data.rse, data.posts, data.available) : null
}

export default class Stuff {
  constructor(id, name, image, description,  type, level = 1, buyingMode, price, amortization, lossOnSale, paimentDelay, charges, maintnanceCost, rse, posts, available = true) {
    this.id = id
    this.name = name
    this.image = image
    this.description = description
    this.type = type
    this.level = level
    this.buyingMode = buyingMode
    this.price = price
    this.amortization = amortization
    this.lossOnSale = lossOnSale
    this.paimentDelay = paimentDelay
    this.charges = charges
    this.maintnanceCost = maintnanceCost
    this.rse = rse
    this.posts = posts
    this.available = available
  }

  static initOne() {
    return new Stuff(null, 'Nouvel équipement', 'Voiture', '', 'Voiture', 1, 'Buy', 20000, 60, 5, 0, 1500, 2500, 50, 1, true)
  }

  async save() {
    const data = {
      name: this.name,
      image: this.image,
      description: this.description,
      type: this.type,
      level: this.level,
      buyingMode: this.buyingMode,
      price: this.price,
      amortization: this.amortization,
      lossOnSale: this.lossOnSale,
      paimentDelay: this.paimentDelay,
      charges: this.charges,
      maintnanceCost: this.maintnanceCost,
      rse: this.rse,
      posts: this.posts,
      available: this.available
    }

    if (this.id) {
      await catalogueCommands.stuff.update(this.id, data)
    } else {
      const result = await catalogueCommands.stuff.create(data)
      this.id = result.id
    }
    return this
  }

  static async listenAll(callback) {
    onSnapshot(collection(db, await getCollectionPath(collectionName)), snapshot => {
      const list = []
      snapshot.forEach(doc => {
        list.push(docToInstance(doc))
      })
      callback(list)
    })
  }

  static async listenById(id, callback) {
    return onSnapshot(doc(db, await getCollectionPath(collectionName), id), snapshot => {
      callback(docToInstance(snapshot))
    })
  }

  static async getAll(){
    const documents = await getDocs(collection(db, await getCollectionPath(collectionName)))
    return documents.docs.map(docToInstance)
  }


  async delete() {
    await catalogueCommands.stuff.delete(this.id)
  }
}
